import React, { useContext, useState, useEffect } from 'react';  
import proyectoContext from '../../context/proyectos/proyectoContext';
import criticaContext from '../../context/criticas/criticaContext';
import Swal from 'sweetalert2';




const FormCritica = () => {


    // Extrar si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;

    // obtener la función del context de critica
    const criticasContext = useContext(criticaContext);
    const { criticaseleccionada, errorcritica, estadoformulario, agregarCritica, validarCritica, obtenerCriticas, actualizarCritica, limpiarCritica } = criticasContext;

    // Effect que detecta si hay una critica seleccionada
    useEffect(() => {
        if(criticaseleccionada !== null) {
            guardarCritica(criticaseleccionada)
        } else {
            guardarCritica({
                nombre: ''
            })
        }
    }, [  criticaseleccionada]); 

    // State del formulario
    const [critica, guardarCritica] = useState({
        year: '',
        poster: '',
        nombre: '',
        detalle: '',
        fechaEnVerla: '',
        espectadores: '',
        calificacion: '',
    })

    const [isNotANumber, guardarisNotANumber] = useState(false)

    // extraer el nombre del proyecto
    const { nombre, detalle, fechaEnVerla, espectadores, calificacion } = critica;

    // Si no hay proyecto seleccionado
    if(!proyecto) return null;

    // Array destructuring para extraer el proyecto actual
    const [proyectoActual] =  proyecto;

    // Leer los valores del formulario
    const handleChange = e => {
        guardarCritica({
            ...critica,
            [e.target.name] : e.target.value
        })
    }

    

    const onSubmit = e => {
        e.preventDefault();
        // validar
        if(nombre.trim() === '' || detalle.trim() === '' || fechaEnVerla.trim() === '' || espectadores.trim() === '' || calificacion === '') {
            validarCritica();
            return;
        }
        if(isNaN(calificacion)){
            guardarisNotANumber(true);
            return;
        }

        // Si es edición o si es nueva critica
        if(criticaseleccionada === null ) {
            
            // agregar la nueva critica al state de criticas
            critica.proyecto = proyectoActual._id;

            agregarCritica(critica);

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Su crítica ha sido creada con éxito',
                showConfirmButton: false,
                timer: 1500
              })

            //console.log(critica)

        } else {
            
            // actualizar critica existente
            actualizarCritica(critica);
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Su crítica ha sido actualizada con éxito',
                showConfirmButton: false,
                timer: 1500
              })

            

            // Elimina criticaseleccionada del state
            limpiarCritica();
        }
        // Obtener y filtrar las criticas del proyecto actual
        obtenerCriticas(proyectoActual.id);

        // reiniciar el form
        guardarCritica({
            nombre: '',
            detalle: '',
            fechaEnVerla: '',
            espectadores: '',
            calificacion: '',
        })
    }

      

    return ( 
        <div>
        { estadoformulario ? (
            <div className="formulario">
        { isNotANumber ? <p className="mensaje error">El puntaje debe ser en numeros!</p> : null }
            <form
                onSubmit={onSubmit}
            >
                <div class="form__group field">
                <input type="input" class="form__field" placeholder="Name" name="nombre" value={nombre} onChange={handleChange} required />
                <label for="name" class="form__label">Nombre de la película o serie </label>
                </div>

                <div class="form__group field">
                <textarea type="input" class="form__field" placeholder="Name" name="detalle" value={detalle} onChange={handleChange} required />
                <label for="name" class="form__label">¿Qué te pareció?</label>
                </div>

                <div class="form__group field">
                <input type="date" class="form__field" placeholder="Name" value={fechaEnVerla} name="fechaEnVerla" onChange={handleChange} required />
                <label for="name" class="form__label">¿Cuando la viste?</label>
                </div>

                <div class="form__group field">
                <input type="input" class="form__field" placeholder="Name" value={espectadores} name="espectadores" onChange={handleChange} required />
                <label for="name" class="form__label">¿En compañía o solo?</label>
                </div>

                <div class="form__group field">
                <input type="input" class="form__field" placeholder="Name" value={calificacion} name="calificacion" onChange={handleChange} required />
                <label for="name" class="form__label">¿Que puntuación le ponés?</label>
                </div>

                <div className="contenedor-input">

                    
                    <input 
                        type="submit"
                        className="btn btn-primario btn-submit btn-block"
                        value={criticaseleccionada ? 'Editar Crítica' : 'Agregar crítica'}
                    />
                </div>
            </form>

            

            {errorcritica ? <p className="mensaje error">Todos los valores son necesarios </p> : null }


        </div>
        ) 
        : null }
        </div>
     );
}
 
export default FormCritica;